import * as $ from 'jquery';

export default (
    function() {
        jQuery('#participant_selector').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            let $current = jQuery(this[clickedIndex]);
            if(isSelected) {
                jQuery('#selected-participants tbody')
                    .append(jQuery('<tr data-participant-id="'+$current.val()+'">')
                        .append(jQuery('<td>')
                            .append($current.text())
                            .append('<input type="hidden" name="items['+$current.attr('data-edition-id')+'][]" value="'+$current.val()+'" />')
                        )
                    )
            } else {
                // remove
                jQuery('#selected-participants tbody tr[data-participant-id="'+$current.val()+'"]').remove();
            }
        });
    }()
);


